import './children-list.scss';
import type { AccountForChildEligibilityDetails } from '@generated-types';
import { useChildEligibilities } from '@react-query/hooks/query/use-child-eligibilities';
import { useTranslation } from '@translations';
import { MyChildrenError } from '../my-children-error/my-children-error';
import { NoChildrenWarning } from '../no-children-warning/no-children-warning';
import { ChildCard } from './child-card/child-card';
import { ChildrenListSkeleton } from './skeleton/children-list-skeleton';

export const ChildrenList = () => {
    const { data: childEligibilities, isPending, error } = useChildEligibilities();

    if (isPending) {
        return <ChildrenListSkeleton />;
    }

    if (error) {
        return <MyChildrenError />;
    }

    if (childEligibilities.length === 0) {
        return <NoChildrenWarning />;
    }

    return (
        <div>
            <Header />
            <ul className="children-list" data-testid="children-list">
                {childEligibilities.map((childEligibility) => (
                    <ListItem key={childEligibility.child.name} childEligibility={childEligibility} />
                ))}
            </ul>
        </div>
    );
};

const Header = () => {
    const { listOfChildren } = useTranslation();

    return (
        <h2 id="children-list-title" className="children-list-heading">
            {listOfChildren.header}
        </h2>
    );
};

interface ListItemProps {
    childEligibility: AccountForChildEligibilityDetails;
}

const ListItem = ({ childEligibility }: ListItemProps) => (
    <ChildCard childEligibility={childEligibility}>
        <div className="children-list-item__content">
            <div className="children-list-item__content__details">
                <ChildCard.Name />
                <ChildCard.Tag />
                <ChildCard.EligibilityStatus />
            </div>
            <ChildCard.Actions />
        </div>
    </ChildCard>
);
